(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["dp-card-spacing"] && !Shopify.designMode) return;
  try {
    (() => {
  let pending = false;
  const selectors = ['.product__vendor', '.product-grid-item__titles', '.product-grid-item__price', '.dp-stock'];
  const align = () => {
    pending = false;
    const cards = Array.from(document.querySelectorAll('.product-grid-item__content')).filter(card => card.getBoundingClientRect().width > 0);
    cards.forEach(card => selectors.forEach(selector => {
      const element = card.querySelector(selector);
      if (element) element.style.removeProperty('height');
    }));
    const rows = [];
    cards.forEach(card => {
      const top = card.getBoundingClientRect().top;
      const parent = card.closest('.swiper-wrapper, #product-grid, .product-grid') || card.parentElement.parentElement.parentElement;
      let row = rows.find(row => row.parent === parent && Math.abs(row.top - top) < 4);
      if (!row) { row = { parent, top, cards: [] }; rows.push(row); }
      row.cards.push(card);
    });
    rows.filter(row => row.cards.length > 1).forEach(row => selectors.forEach(selector => {
      const elements = row.cards.map(card => card.querySelector(selector)).filter(Boolean);
      const height = Math.max(0, ...elements.map(element => element.getBoundingClientRect().height));
      elements.forEach(element => { element.style.height = `${height}px`; });
    }));
  };
  const schedule = () => {
    if (!pending) { pending = true; requestAnimationFrame(align); }
  };
  window.addEventListener('resize', schedule);
  window.addEventListener('load', schedule);
  document.addEventListener('shopify:section:load', schedule);
  new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  if (document.fonts) document.fonts.ready.then(schedule);
  schedule();
})();
  } catch(e) { console.error(e); }
})();

})();
